/*
 * Copyright (C) 2018 Robert Bosch GmbH Copyright (C) 2018 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */

import { ComponentType } from "@angular/cdk/portal";
import { DOCUMENT } from "@angular/common";
import { Inject, Injectable, OnInit, TemplateRef } from "@angular/core";
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from "@angular/material/dialog";

/**
 * Use this service to open dialogs/modal windows.
 * Future updates will ship with a standard dialog containing a header, content, action buttons and close icon button
 */
@Injectable({
  providedIn: "root"
})
export class ModalWindowService {
  constructor(
    private matDialog: MatDialog,
    @Inject(DOCUMENT) private document: any
  ) {}

  /**
   * Opens a modal dialog containing the given component.
   * @param componentOrTemplateRef Type of the component to load into the dialog,
   *     or a TemplateRef to instantiate as the dialog content.
   * @param config Extra configuration options.
   * @param matDialog inject MatDialog in constructor in components contained in lazy-loaded Modules
   * @returns Reference to the newly-opened dialog.
   */
  public openDialogWithComponent<T, D = any, R = any>(
    componentOrTemplateRef: ComponentType<T> | TemplateRef<T>,
    config?: MatDialogConfig<D>,
    matDialog?: MatDialog
  ): MatDialogRef<T, R> {
    const matDialogUsed =
      matDialog !== null && matDialog !== undefined
        ? matDialog
        : this.matDialog;
    const dialogRef = matDialogUsed.open<T, D, R>(
      componentOrTemplateRef,
      config
    );
    if (dialogRef && matDialogUsed.openDialogs.length > 0) {
      this.document.body.classList.remove("modal-closed");
      this.document.body.classList.add("modal");

      dialogRef.beforeClosed().subscribe(() => {
        if (matDialogUsed.openDialogs.length === 1) {
          this.document.body.classList.remove("modal");
          this.document.body.classList.add("modal-closed");
        }
      });
    }
    return dialogRef;
  }
}
